import React, {Component, PropTypes } from 'react';
import { formatDate } from '../../utils/date';
import { format } from '../../utils/string';
import { lang } from '../../strings';

export default class SubscriptionDetails extends Component {

   render() {
      let { subscription } = this.props;
      let { number, subscriptionTemplateName, monthlyFee, variableFee, additionalFee, contractLength, contractEndDate, freeMonthsEndDate, customerNumber } = subscription;

      return (
         <div>
            <h2 className="color-primary no-margin-bottom">{number || subscriptionTemplateName}</h2>
            {number && <h3 className="h5 color-dark-blue">{subscriptionTemplateName}</h3>}
            {this.renderTasks()}
            <div className="mp-block">
               <div className="mp-block-half">
                  <table className="mp-table">
                     <tbody>
                     <tr>
                        <td><strong>{lang.subscription.monthlyFee}</strong></td>
                        <td>{this.currency(monthlyFee)}</td>
                     </tr>
                     {variableFee > 0 && (
                        <tr>
                           <td><strong>{lang.subscription.variableFee}</strong></td>
                           <td>{this.currency(variableFee)}</td>
                        </tr>
                     )}
                     <tr>
                        <td><strong>{lang.subscription.additionalFee}</strong></td>
                        <td>{this.currency(additionalFee)}</td>
                     </tr>
                     {freeMonthsEndDate && (
                        <tr>
                           <td><strong>{lang.subscription.freeMonthsEndDate}</strong></td>
                           <td>{formatDate(freeMonthsEndDate, 'L')}</td>
                        </tr>
                     )}
                     </tbody>
                  </table>
               </div>
               <div className="mp-block-half">
                  <table className="mp-table">
                     <tbody>
                     <tr>
                        <td><strong>{lang.subscription.customerNumber}</strong></td>
                        <td>{customerNumber}</td>
                     </tr>
                     <tr>
                        <td><strong>{lang.subscription.contractLength}</strong></td>
                        <td>{contractLength} mån</td>
                     </tr>
                     <tr>
                        <td><strong>{lang.subscription.endDate}</strong></td>
                        <td>{formatDate(contractEndDate, 'L')}</td>
                     </tr>
                     </tbody>
                  </table>
               </div>
            </div>
         </div>
      );
   }

   renderTasks() {
       let { conversionTasks, terminationTasks, numberChangeTasks, transferTasks } = this.props;
       return (
           <div>
               {conversionTasks && conversionTasks.length > 0 ?  conversionTasks.map(task => <p className="mp-task-info">{format(lang.subscription.tasks.conversion, task.newSubscriptionTemplateName, formatDate(task.activationDate, 'LL'))}</p>) : null}
               {terminationTasks && terminationTasks.length > 0 ? terminationTasks.map(task => <p className="mp-task-info">{format(lang.subscription.tasks.termination, this.terminationDate(task.activationDate))}</p>) : null}
               {numberChangeTasks && numberChangeTasks.length > 0 ? numberChangeTasks.map(task => <p className="mp-task-info">{format(lang.subscription.tasks.numberChange, task.newNumber, formatDate(task.activationDate, 'LL'))}</p>) : null}
               {transferTasks && transferTasks.length > 0 ? transferTasks.map(task => <p className="mp-task-info">{format(lang.subscription.tasks.transfer, task.customerName, task.orgNumber, formatDate(task.activationDate, 'LL'))}</p>) : null}
           </div>
       )
   }
   
   terminationDate(date) {
      return date ? formatDate(date, 'LL') : lang.subscription.tasks.outPorting;
   }

   currency(value) {
      return parseFloat(value).toLocaleString('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kr';
   }
}

SubscriptionDetails.propTypes = {
   subscription: PropTypes.object.isRequired
};